import { Box, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { Language } from '@mui/icons-material';

export interface WebSourceAnnotation {
  url: string;
  title: string;
}

interface WebSourcesProps {
  sources: WebSourceAnnotation[];
  onClick: () => void;
}

export const WebSources = ({ sources, onClick }: WebSourcesProps) => {
  const theme = useTheme();

  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        cursor: 'pointer',
        padding: '4px 8px',
        borderRadius: '8px',
        transition: 'background-color 0.2s ease',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      }}
    >
      <Language
        sx={{
          fontSize: '18px',
          color: theme.palette.text.secondary,
        }}
      />
      <Text
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          fontWeight: 700,
        }}
      >
        {sources.length} Web Source{sources.length !== 1 ? 's' : ''}
      </Text>
    </Box>
  );
};
